'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.tpFirmwares.edit', [])
  .controller('TpFirmwaresEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/tpFirmwares/edit/index.js